import React from "react";
import "./About.css";
import profileImage from "../assets/profile_cartoon.png";

const skillGroups = [
  {
    label: "Backend",
    skills: ["Java", "Spring Boot", "Spring Security", "Spring Framework", "Maven", "Gradle",
      "REST API", "JUnit", "Mockito", "Hibernate", "JPA"],
  },
  {
    label: "Frontend",
    skills: ["React", "TypeScript", "JavaScript", "HTML", "CSS", "Next.js",
      "Tailwind CSS", "Material UI"],
  },
  {
    label: "Mobile",
    skills: ["React Native", "Expo", "Android Studio", "React Native CLI",
      "Play Store Publishing", "Push Notifications", "Responsive Design"],
  },
  {
    label: "Databases",
    skills: ["MySQL", "PostgreSQL", "MongoDB", "Firebase", "SQL"],
  },
  {
    label: "DevOps & Cloud",
    skills: ["Docker", "AWS EC2", "S3", "AWS Cloud", "CI/CD",
      "GitHub Actions", "Git", "GitHub", "GitLab"],
  },
  {
    label: "Tools & Methods",
    skills: ["OpenAPI", "Postman", "Swagger", "IntelliJ IDEA", "VS Code",
      "Figma", "Agile", "Scrum", "TDD"],
  },
];

function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        <div className="profile-container">
          <img src={profileImage} alt="Samer Skayir" className="profile-image" />
        </div>

        <div className="about-text">
          <h1 className="about-title">About Me</h1>
          <p>
            I'm a dedicated software developer with a background in education,
            where I worked for over <strong>10 years</strong>. That career gave me a strong
            foundation in structure, pedagogy, and clear communication - skills I now
            bring into <strong>every technical project</strong>.
          </p>
          <p>
            My passion for technology grew steadily over the years, and today I
            focus on building applications that combine <strong>smart functionality</strong> with
            clean, user-friendly design.
          </p>
          <p>
            I specialise in <strong>Java, Spring Boot, REST APIs</strong>, and <strong>React</strong>, and
            enjoy working across the full stack - from database design to polished UI.
          </p>
          <p>
            Driven by curiosity, I keep growing every day - in code, in teams,
            and as a problem-solver. This portfolio itself is a working example:
            built from scratch with <strong>React, Framer Motion, and React Router</strong> as
            a live demonstration of my frontend skills.
          </p>

          <div className="about-stats">
            <div className="stat-item">
              <span className="stat-number">10+</span>
              <span className="stat-label">Years in Education</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">4</span>
              <span className="stat-label">Apps on Google Play</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">3+</span>
              <span className="stat-label">Full-Stack Projects</span>
            </div>
          </div>

          <div className="cv-buttons">
            <a
              href="/CV_SAMER_SVENSKA.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="download-cv-button"
            >
              View CV in Swedish
            </a>
            <a
              href="/CV_SAMER_ENGELSKA.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="download-cv-button"
            >
              View CV in English
            </a>
          </div>
        </div>
      </div>

      <div className="skills-section">
        <h2 className="skills-title">Skills &amp; Technologies</h2>
        <div className="skill-groups">
          {skillGroups.map((group) => (
            <div key={group.label} className="skill-group">
              <h3 className="skill-group-label">{group.label}</h3>
              <div className="skill-tags">
                {group.skills.map((skill) => (
                  <span key={skill} className="skill">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default About;
